// removed by extract-text-webpack-plugin
module.exports = {"datePickerRoot":"CwDatePicker-datePickerRoot"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwdatepicker/CwDatePicker.scss
// module id = 360
// module chunks = 0